// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"ddd535da","156":"4aff9f57","257":"6c4e55ef","463":"9bcbe6a1","465":"105be2c2","484":"a2498cd9","621":"1e9f348f","639":"93d7613f","787":"13c8bd47","892":"d6ca7b94"}[chunkId] + ".chunk.js";
};